module.exports = __webpack_public_path__ + "img/instacash-inner-logo.6f3fcc5e.svg";